import React from 'react'
import ManageTerms from '../ManageTerms'

export default function ManageFacilityTnCs({ facility }) {
    return (
        <ManageTerms facility={facility} />
    )
}
